<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import JsryzcxxbgBrowse from "./JsryzcxxbgBrowse";
import JsryzcxxbgEdit from "./JsryzcxxbgEdit";
import JsryzcxxbgForm from "./JsryzcxxbgForm";
export default {
    name: "jsryzcxxbg",
    components: { JsryzcxxbgBrowse, JsryzcxxbgEdit, JsryzcxxbgForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "JsryzcxxbgEdit";
            } else if (this.editProps.showForm === true) {
                return "JsryzcxxbgForm";
            } else {
                return "JsryzcxxbgBrowse";
            }
        }
    }
};
</script>
